<template>
  <!--    main-->
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con">
        <div class="complete">
          <img src="@/assets/static/images/img_search.svg" alt="" class="complete__img">
          <p class="complete__txt"><span class="primary">{{ userData.companyName }}님,</span><br>관리자가 회원 정보를 확인하고 있습니다.</p>
          <p class="complete__txt__small">회원 승인이 완료된 이후에 서비스 이용이 가능합니다.<br>(진행사항 문의는 1588-9138 으로 별도 연락 바랍니다.)</p>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  data: function () {
    return {
    }
  },
  computed: {
    userData: function() {
      return this.$store.getters['account/getUserData']
    }
  }
}
</script>

